import { css } from 'emotion';
import { observer } from 'mobx-react';
import * as React from 'react';
import Slider from 'react-slick';

import { AddOnItem } from './AddOnItem';

import arrowLeft from '../assets/addOn/left-scroll-icon.svg';
import arrowRight from '../assets/addOn/right-scroll-icon.svg';

import { BREAKPOINT_SMALL } from '../consts/breakpoints';
import { carouselContainer } from '../styles/carouselContainer';

const containerModifications = css`
  max-width: 1200px;
  width: 100%;

  margin: 0 auto;
  .slick-slider {
    @media (min-width: ${BREAKPOINT_SMALL}) {
      margin: 0px 40px 0px 40px;
    }

    .slick-list {
      flex: 1;
    }
  }
  .slick-next {
    position: absolute;
    right: 5px;
    top: 50%;
    z-index: 5;
    @media (min-width: ${BREAKPOINT_SMALL}) {
      position: absolute;
      right: -30px;
      top: 50%;
      z-index: 1;
    }
  }

  .slick-prev {
    position: absolute;
    left: 5px;
    top: 50%;
    z-index: 5;
    @media (min-width: ${BREAKPOINT_SMALL}) {
      position: absolute;
      left: -30px;
      top: 40%;
      z-index: 1;
    }
  }
  .slick-track {
    display: flex;
  }

  .slick-track .slick-slide {
    display: flex;
    height: auto;
    align-items: center;
    justify-content: center;
  }

  .slick-slide > div {
    height: 100%;
    width: 400px;
  }
`;

function Arrow(props: any) {
  const { className, onClick, arrowDirection } = props;
  const arrowImage = arrowDirection === 'left' ? arrowLeft : arrowRight;
  const style = {
    background: `url(${arrowImage})`,
    cursor: 'pointer',
    display: 'block',
    height: '25px',
    width: '25px',
  };

  return <div className={className} style={style} onClick={onClick} role="region" />;
}

interface IAddOnSelectorProps {
  items?: Array<{
    title: string;
    price: number;
    id: number;
    currency: string;
    message: string;
    addOnImage: string;
    isSelected?: boolean;
  }>;
  onSelectedItem(id?: number): any;
}

const ArrowWrapper = ({ children, ...props }: any) => <div {...props}>{children}</div>;
@observer
export class AddOnSelector extends React.Component<IAddOnSelectorProps> {
  public render() {
    const { items, onSelectedItem } = this.props;

    const responsiveBreakpoints = [
      {
        breakpoint: 420,
        settings: {
          centerPadding: '20px',
          infinite: false,
          slidesToShow: 1.1,
        },
      },
      {
        breakpoint: 550,
        settings: {
          infinite: false,
          slidesToShow: 1.3,
        },
      },
      {
        breakpoint: 750,
        settings: {
          infinite: false,
          slidesToShow: 1.4,
        },
      },
      {
        breakpoint: 990,
        settings: {
          infinite: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1530,
        settings: {
          infinite: false,
          slidesToShow: items && items.length >= 3 ? 3 : items && items.length,
        },
      },
    ];

    return (
      <div className={`${containerModifications} ${carouselContainer}`}>
        <Slider
          arrows
          infinite={false}
          nextArrow={
            <ArrowWrapper>
              <Arrow arrowDirection={'right'} />
            </ArrowWrapper>
          }
          prevArrow={
            <ArrowWrapper>
              <Arrow arrowDirection={'left'} />
            </ArrowWrapper>
          }
          responsive={responsiveBreakpoints}
          slidesToScroll={1}
          slidesToShow={items && items.length >= 3 ? 3 : items && items.length}
          speed={500}
        >
          {items &&
            items.map(({ title, price, currency, message, addOnImage, isSelected, id }) => (
              <AddOnItem
                key={title}
                id={id}
                title={title}
                price={price}
                currency={currency}
                message={message}
                addOnImage={addOnImage}
                isSelected={isSelected}
                onClick={onSelectedItem}
              />
            ))}
        </Slider>
      </div>
    );
  }
}
